module.exports = __webpack_public_path__ + "static/media/subcription_cancelled_screen.6e4dcffe.svg";